import * as React from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { useTranslations } from "next-intl";
import { Button, FormField, Input, useToast } from "@chotca/ui";
import { vi } from "@chotca/config";
import { getSdk } from "@chotca/api-client";
import { AuthLayout } from "./auth-layout";
import { errMsg } from "./auth-errors";

export function ResetPasswordPage() {
  const t = useTranslations("auth");
  const { error: toastError, success: toastSuccess } = useToast();
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token") ?? "";
  const [pending, setPending] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setPending(true);
    setError(null);
    const fd = new FormData(e.currentTarget);
    const newPassword = String(fd.get("newPassword") ?? "");
    const confirm = String(fd.get("confirmPassword") ?? "");
    if (newPassword !== confirm) {
      setError(t("passwordMismatch"));
      setPending(false);
      return;
    }
    try {
      await getSdk().auth.confirmPasswordReset({ token, newPassword });
      toastSuccess(t("resetSuccess"));
      nav("/login", { replace: true });
    } catch (err) {
      const msg = errMsg(err, "Đặt lại mật khẩu thất bại");
      setError(msg);
      toastError(msg);
      setPending(false);
    }
  }

  return (
    <AuthLayout
      label={vi.common.login}
      title={t("resetTitle")}
      subtitle={t("resetSubtitle")}
      footer={
        <Link
          to="/login"
          className="font-bold text-ink underline-offset-4 hover:underline"
        >
          {t("loginLink")}
        </Link>
      }
    >
      {!token ? (
        <div className="rounded-xl bg-danger/10 p-3 text-sm text-danger">
          {t("verifyEmailFailed")}
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4">
          <FormField
            label={t("newPasswordLabel")}
            description={t("passwordTooWeak")}
          >
            <Input
              name="newPassword"
              type="password"
              autoComplete="new-password"
              required
              minLength={8}
              autoFocus
            />
          </FormField>
          <FormField label={t("passwordLabel")}>
            <Input
              name="confirmPassword"
              type="password"
              autoComplete="new-password"
              required
              minLength={8}
            />
          </FormField>

          {error ? (
            <p className="rounded-xl bg-danger/10 p-3 text-sm text-danger">
              {error}
            </p>
          ) : null}

          <Button type="submit" fullWidth loading={pending} size="lg">
            {t("resetCta")}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
